import FormControlLabelInner from './FormControlLabelInner'

export default FormControlLabelInner
